import React from "react";
import { SelectRows } from "./hooks/grid/useSelectRows";

const SelectRowsContext = React.createContext<SelectRows<unknown> | null>(null);

export { SelectRowsContext };
